<template>
  <div>
    <div v-if="visivel" class="fullscreen" @click="esconderImagem">
      <img :src="scrImagem" onerror="this.onerror=null; this.src='./img/semimagem.png'">
      <span>
        <i class="cardapio-digital-detalhe-produto-section-btn-voltar 
          is-clickable 
          fas fa-arrow-left">
        </i> 
        Voltar
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scrImagem: String,
    visivel: Boolean
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    esconderImagem() {
      this.$emit('esconderImagem');
    },
  },
};
</script>

<style lang="scss">
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
    &:hover {
      cursor: pointer;
    }
}

.fullscreen img {
  max-width: 100%;
  max-height: 100%;
}

.fullscreen span {
  position: fixed;
  font-size: 1.3rem;
  color: #363636;
  padding: 6px 17px;
  border-radius: 15px;
  bottom: 60px;
  background-color: #EBE8E8;
}
</style>
